import { timestamp as ts } from "$lib/utils/timestamp";
import { getContext, setContext } from "svelte";


const CONTEXT = Symbol("UI")

export function createHeaderVisiblityContext(): HeaderVisiblityContext {
  return setContext(CONTEXT, new HeaderVisiblityContext());
}

export function getHeaderVisiblityContext(): HeaderVisiblityContext {
  return getContext(CONTEXT)
}


export class HeaderVisiblityContext {
  globalMenuVisibility = $state(false)
  menuRequested = $state( new Set() )
  menuOpen = $state(false)

  bodyScroll = $state(true)

  menuRequestedChange = $state( ts() )
  
  constructor() {
    return this
  }

  forceMenuVisible() {
    this.resetRequests()
    this.globalMenuVisibility = true
    this.menuOpen = true
    return this
  }
  
  forceMenuHidden() {
    this.resetRequests()
    this.globalMenuVisibility = false
    this.menuOpen = false
    return this
  }

  resetRequests() {
    this.menuRequested = new Set()
    return this
  }
  
  //request visible menu, but do not change global visibility state
  requestMenuVisible( element: any ) {
    this.menuRequestedChange = ts()
    this.menuRequested.add(element)
    //this.menuRequested = new Set([...this.menuRequested])
    this.menuOpen = true
    return this
  }
  
  //release visible menu, but do not change current state
  releaseMenuVisible( element: any ) {
    this.menuRequestedChange = ts()
    if( this.menuRequested.has(element) ) {
      this.menuRequested.delete(element)
      //this.menuRequested = new Set([...this.menuRequested])
      return this
    }
    return this
  }
}


export function createScrollBlockContext(): ScrollBlockContext {
  return setContext("SCROLLBLOCK", new ScrollBlockContext());
}

export function getScrollBlockContext(): ScrollBlockContext {
  return getContext("SCROLLBLOCK")
}


export class ScrollBlockContext {
  bodyScrollBlockRequested = $state( new Set() )
  bodyScrollBlocked = $state(false)

  bodyScrollBlockedChange = $state(ts())

  constructor() {
    this
  }

  requestBodyScrollBlock( element: any ) {
    this.bodyScrollBlockedChange = ts()
    this.bodyScrollBlockRequested.add(element)
    //this.bodyScrollBlockRequested = new Set([...this.bodyScrollBlockRequested])
    this.bodyScrollBlocked = true
    return this
  }
  
  releaseBodyScrollBlock( element: any ) {
    this.bodyScrollBlockedChange = ts()
    if( this.bodyScrollBlockRequested.has(element) ) {
      this.bodyScrollBlockRequested.delete(element)
      //this.bodyScrollBlockRequested = new Set([...this.bodyScrollBlockRequested])
      if( this.bodyScrollBlockRequested.size == 0 ) this.bodyScrollBlocked = false
      return this
    }
    return this
  }

}